"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvatarDtoSourceEnum = exports.AvatarDtoFileTypeEnum = void 0;
exports.instanceOfAvatarDto = instanceOfAvatarDto;
exports.AvatarDtoFromJSON = AvatarDtoFromJSON;
exports.AvatarDtoFromJSONTyped = AvatarDtoFromJSONTyped;
exports.AvatarDtoToJSON = AvatarDtoToJSON;
exports.AvatarDtoToJSONTyped = AvatarDtoToJSONTyped;
/**
 * @export
 */
exports.AvatarDtoFileTypeEnum = {
    Pdf: 'pdf',
    Docx: 'docx',
    Doc: 'doc',
    Webp: 'webp',
    Png: 'png',
    Jpg: 'jpg',
    Jpeg: 'jpeg',
    Mp4: 'mp4',
    Webm: 'webm',
    Ogg: 'ogg',
    Mov: 'mov',
    Avi: 'avi',
    Mkv: 'mkv',
    M4v: 'm4v'
};
/**
 * @export
 */
exports.AvatarDtoSourceEnum = {
    CloudFlareR2: 'cloud_flare_r2',
    Crm: 'crm'
};
/**
 * Check if a given object implements the AvatarDto interface.
 */
function instanceOfAvatarDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('source' in value) || value['source'] === undefined)
        return false;
    return true;
}
function AvatarDtoFromJSON(json) {
    return AvatarDtoFromJSONTyped(json, false);
}
function AvatarDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'fileUrl': json['fileUrl'] == null ? undefined : json['fileUrl'],
        'fileName': json['fileName'] == null ? undefined : json['fileName'],
        'fileType': json['fileType'] == null ? undefined : json['fileType'],
        'altText': json['altText'] == null ? undefined : json['altText'],
        'source': json['source'],
        'sourceId': json['sourceId'] == null ? undefined : json['sourceId'],
        'createdAt': json['createdAt'] == null ? undefined : json['createdAt'],
    };
}
function AvatarDtoToJSON(json) {
    return AvatarDtoToJSONTyped(json, false);
}
function AvatarDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'fileUrl': value['fileUrl'],
        'fileName': value['fileName'],
        'fileType': value['fileType'],
        'altText': value['altText'],
        'source': value['source'],
        'sourceId': value['sourceId'],
        'createdAt': value['createdAt'],
    };
}
